<ng-container *ngIf="sites != null">
    <h4 class="section-heading">
        <span>Sites</span>
        <div></div>
    </h4>
    <div class="horizontal-container">
        <button
            type="button"
            class="btn-circle btn-link"
            (click)="newSite()"
            [disabled]="working || !canEdit"
            tooltip="Add Site"
            placement="right"
        >
            <span class="fa fa-plus"></span>
        </button>
        <div class="fill">
            <table class="table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Description</th>
                        <th>
                            <div class="checkbox pull-right" style="margin: 0">
                                <mat-slide-toggle
                                    [(ngModel)]="showArchived"
                                    [ngModelOptions]="{ standalone: true }"
                                >
                                    Show archived sites?
                                </mat-slide-toggle>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let site of sites">
                        <tr *ngIf="showArchived || !site.archived" class="data">
                            <td>
                                {{ site.name }} @if(site.organisation.id !==
                                organisationId) {<em
                                    >({{ site.organisation.name }})</em
                                >}
                            </td>
                            <td>{{ site.description }}</td>
                            <td class="actions">
                                <ng-container
                                    *ngIf="
                                        canEdit &&
                                        site.organisation.id === organisationId
                                    "
                                >
                                    <button
                                        type="button"
                                        class="btn btn-tertiary"
                                        (click)="editSite(site)"
                                        [disabled]="working"
                                        tooltip="Edit"
                                        placement="left"
                                    >
                                        <span class="fal fa-pencil-alt"></span>
                                    </button>
                                    <button
                                        *ngIf="!site.archived"
                                        type="button"
                                        class="btn btn-tertiary"
                                        (click)="editSiteAreas(site)"
                                        [disabled]="working"
                                        tooltip="Edit Site Areas"
                                        placement="left"
                                    >
                                        <span class="fal fa-map"></span>
                                    </button>
                                    <button
                                        *ngIf="!site.archived"
                                        type="button"
                                        class="btn btn-tertiary"
                                        (click)="archiveSite(site)"
                                        [disabled]="working"
                                        tooltip="Archive"
                                        placement="left"
                                    >
                                        <span class="fal fa-archive"></span>
                                    </button>
                                    <button
                                        *ngIf="site.archived"
                                        type="button"
                                        class="btn btn-tertiary"
                                        (click)="unarchiveSite(site)"
                                        [disabled]="working"
                                        tooltip="Unarchive"
                                        placement="left"
                                    >
                                        <span class="fal fa-box-open"></span>
                                    </button>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-container>
                    <tr *ngIf="sites.length === 0">
                        <td colspan="3">
                            <div class="alert alert-info" role="alert">
                                No sites have been created yet. Use the button
                                above to add a new site.
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</ng-container>
